import React from 'react';
import { XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Area, AreaChart } from 'recharts';
import { fm } from '../../utils';

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-white dark:bg-surface-800 border border-surface-200 dark:border-surface-700 rounded-xl shadow-lg p-3 text-xs">
      <p className="font-semibold text-surface-700 dark:text-surface-300 mb-1">{label}</p>
      {payload.map((p, i) => (
        <p key={i} className="text-surface-500" style={{ color: p.color }}>
          {p.name}: <span className="font-semibold">{fm(p.value)}</span>
        </p>
      ))}
    </div>
  );
};

const SalesChart = ({ data = [], dataKey = 'tutar', xKey = 'label', title = 'Satış Trendi', color = '#10b981', gradient = true }) => (
  <div className="bg-white dark:bg-surface-800 rounded-2xl border border-surface-100 dark:border-surface-700 shadow-soft p-4">
    <h4 className="text-[11px] font-semibold text-surface-400 uppercase tracking-wider mb-3">{title}</h4>
    {data.length === 0 ? (
      <div className="h-48 flex items-center justify-center text-xs text-surface-300">Veri bulunamadı</div>
    ) : (
      <div className="h-48">
        <ResponsiveContainer>
          <AreaChart data={data}>
            <defs>
              <linearGradient id="salesGrad" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor={color} stopOpacity={0.15} />
                <stop offset="100%" stopColor={color} stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
            <XAxis dataKey={xKey} tick={{ fontSize: 10, fill: '#94a3b8' }} axisLine={false} tickLine={false} />
            <YAxis tick={{ fontSize: 10, fill: '#94a3b8' }} axisLine={false} tickLine={false} tickFormatter={v => fm(v)} />
            <Tooltip content={<CustomTooltip />} />
            <Area type="monotone" dataKey={dataKey} stroke={color} fill="url(#salesGrad)" strokeWidth={2} name="Tutar" />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    )}
  </div>
);

export default SalesChart;
